import Icon from '../components/Icon.vue'

Icon.register({"level-down":{"width":1024,"height":1792,"paths":[{"d":"M32 256h704q13 0 22.5 9.5t9.5 23.5v863h192q40 0 58 37t-9 69l-320 384q-18 22-49 22t-49-22l-320-384q-26-31-9-69 18-37 58-37h192v-640h-320q-14 0-25-11l-160-192q-13-14-4-34 9-19 29-19z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/level-down.js
// module id = 1064
// module chunks = 0